import { useState, useContext } from "react";
import { Button, CircularProgress, Modal, Typography } from "@mui/material";
import { Box } from "@mui/system";
import SelectMenu from "../SelectMenu";
import { AppContext } from "../../scripts/context/App";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 500,
  minHeight: 300,
  bgcolor: "#fff",
  borderRadius: "4px",
  boxShadow: 24,
  display: "flex",
  flexDirection: "column",
};

export default function ConfirmDeleteModal({ data, setData, deleteRow, isLoading }: any) {
  const { roles_permissions } = useContext(AppContext);
  const handleClose = () => setData({ status: false });

  return (
    <Modal
      keepMounted
      open={data.status}
      onClose={handleClose}
      aria-labelledby="Role-Modal"
    >
      <Box sx={style}>
        <Box sx={{ p: 3, textAlign: "center", borderBottom: "1px solid #d3d3d3" }}>
          <Typography
            variant="h6"
            component="span"
            sx={{ wordBreak: "break-word" }}
          >
            Please select new role for <Typography variant="h6" component="span" sx={{fontWeight: "bold", textDecoration: "underline"}}>{data.name}</Typography> Role Users before
            deleting it?
          </Typography>
        </Box>
        <Box
          sx={{
            p: 3,
            flex: 1,
          }}
        >
          <SelectMenu
            label="Select New Role"
            handleChange={({ target }) => {
              setData({
                data: {
                  ...data.data,
                  alternative_role_id: target.value,
                },
              });
            }}
            options={
              roles_permissions.filter((item: any) => item.id !== data.data.role_id).map((role: any) => ({
                value: role.id,
                label: role.name,
              }))
            }
            value={data.data.alternative_role_id}
            sx={{ width: "100%", flex: "1 1 40%" }}
          />
        </Box>

        <Box
          sx={{
            borderTop: "1px solid #d3d3d3",
            p: 3,
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={deleteRow}
            disabled={isLoading}
            endIcon={isLoading && <CircularProgress size={20} />}
          >
            Update And Delete
          </Button>
          <Button
            variant="outlined"
            color="error"
            disabled={isLoading}
            onClick={handleClose}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
